import { render, staticRenderFns } from "./ed-deck-cards-navigation.component.vue?vue&type=template&id=2a94d0f1&scoped=true&"
import script from "./ed-deck-cards-navigation.component.ts?vue&type=script&lang=ts&"
export * from "./ed-deck-cards-navigation.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-deck-cards-navigation.component.scss?vue&type=style&index=0&id=2a94d0f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a94d0f1",
  null
  
)

export default component.exports